import React from "react";
import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material/"
import SendIcon from '@mui/icons-material/Send';
import { SoundCloudIcon } from "../custom-icons/Soundcloud.jsx";
import { SpotifyIcon } from "../custom-icons/Spotify.jsx";
import { useLocation, useNavigate } from "react-router-dom";

import "./Footer.css";


const SocialBox = styled(Box)({
  display: "flex",
  gap: 10,
  color: "white",
  width: '100%',
  justifyContent: 'center',
  flexWrap: 'wrap',
});

const Footer = () => {

  let navigate = useNavigate(); 
  const location = useLocation();
  const isContactPage = location.pathname === '/contact/' || location.pathname === '/contact';
  const routeChange = () =>{ 
  let path = `/contact/`; 
    navigate(path);  
  }

  return (
    <Box
      id="Contacts"
      className = "Contacts"
      sx={{ background: "black", minHeight: { xs: "auto", md: "300px" }, py: { xs: 4, md: 7 } }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 2.5, md: 0 }}
        px={{ xs: 2, sm: 4, md: 7 }}
        alignItems={{ xs: 'center', md: 'center' }}
        justifyContent={{ xs: 'center', md: 'space-between' }}
        sx={{ width: '100%', maxWidth: 1200, mx: 'auto' }}
      >
        <Box flex={1} sx={{ width: '100%', maxWidth: { xs: 420, md: '100%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mx: 'auto' }}>
              <Typography color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 'bold', textTransform: 'uppercase', mb: 1 }}>
                Contact
              </Typography>
              {/* <Typography color={"white"} align={"center"}>
                  distorise@gmail.com
              </Typography> */}
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                {!isContactPage ? (
                  <Button
                    onClick={routeChange}
                    variant="contained" 
                    endIcon={<SendIcon />}
                    sx={{
                      width: 'auto',
                      fontFamily: '"Courier New", monospace',
                      fontWeight: 'bold',
                      letterSpacing: '0.06em',
                      textTransform: 'uppercase',
                      px: { xs: 2, sm: 2.5 },
                      py: { xs: 1.05, sm: 1.15 },
                      borderRadius: '999px',
                      border: '1px solid rgba(242, 211, 153, 0.55)',
                      backgroundColor: 'rgba(255,255,255,0.08)',
                      color: 'rgba(255,255,255,0.95)',
                      fontSize: { xs: '0.78rem', sm: '0.85rem' },
                      lineHeight: 1.2,
                      minHeight: { xs: 48, sm: 52 },
                      boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
                      '&:hover': {
                        color: 'black',
                        backgroundColor: 'rgba(242, 211, 153, 0.9)',
                        transform: 'translateY(-1px)'
                      },
                      '& .MuiButton-endIcon': {
                        marginLeft: { xs: 1, sm: 1.25 }
                      }
                    }}>
                    Send Message Right Now
                  </Button>
                ) : (
                  <Typography color={"white"} sx={{ fontFamily: '"Courier New", monospace' }}>
                    You are already on the contact page.
                  </Typography>
                )}
          </Box>
        </Box>
        <Box flex={1} sx={{ width: '100%', display: { xs: 'none', md: 'flex' }, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
          <Typography color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontSize: '0.9rem', lineHeight: 1.6 }}>
            © 2026 Distorise
          </Typography>
          <Typography color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontSize: '0.85rem', opacity: 0.85, lineHeight: 1.6, maxWidth: 320 }}>
            Music.<br />Sound Design &amp; Creative Technology<br />by Vadym D.
          </Typography>
        </Box>
        <Box flex={1} sx={{ width: '100%', maxWidth: { xs: 420, md: '100%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', mx: 'auto' }}>
          <Typography padding={0.5} color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontWeight: 'bold', textTransform: 'uppercase', mb: 0.5 }}>
            Social Media            
          </Typography>          
          <SocialBox>                  

            <SpotifyIcon onClick={() => { window.location.href = 'https://open.spotify.com/artist/1l2XNMmYyIIMOIFY4HFsNU'; }} sx={{ fontSize: 22, cursor: 'pointer', color: 'white', bgcolor: 'black', borderRadius: '50%', p: '3px', '&:hover': { color: 'black', bgcolor: 'white' } }} />
            <SoundCloudIcon onClick={() => { window.location.href = 'https://soundcloud.com/distorise'; }} sx={{ fontSize: 22, cursor: 'pointer', color: 'white', bgcolor: 'black', borderRadius: '50%', p: '3px', '&:hover': { color: 'black', bgcolor: 'white' } }} />
            <Facebook 
                  onClick={() => { window.location.href = 'https://www.facebook.com/distorise/'; }}
                  sx={{
                      cursor: "pointer",
                      color: 'white',
                      bgcolor: "black",
                  borderRadius: '50%',
                  p: '3px',
                  fontSize: 22,
                      '&:hover': {
                          color: "black",
                          bgcolor: "white",
                      }
                  }}
                  />
                  <Instagram 
                  onClick={() => { window.location.href = 'https://www.instagram.com/alan_distorise/'; }}
                  sx={{
                      cursor: "pointer",
                      color: 'white',
                      bgcolor: "black",
                      borderRadius: '50%',
                      p: '3px',
                      fontSize: 22,
                      '&:hover': {
                          color: "black",
                          bgcolor: "white",
                      }
                  }}
                  />
          </SocialBox>
        </Box>
      </Stack>
      <Box
        pb={2.5}
        px={2}
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          mt: 1.5,
          width: '100%',
          maxWidth: 420,
          mx: 'auto',
        }}
      >
        <Typography color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontSize: { xs: '0.82rem', sm: '0.9rem' }, lineHeight: 1.6, width: '100%' }}>
          © 2026 Distorise
        </Typography>
        <Typography color={"white"} align={"center"} sx={{ fontFamily: '"Courier New", monospace', fontSize: { xs: '0.78rem', sm: '0.85rem' }, opacity: 0.85, lineHeight: 1.6, width: '100%' }}>
          Music.<br />Sound Design &amp; Creative Technology<br />by Vadym D.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;